import {
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_ERROR,
} from "./actionTypes";

const initialState = {
  changeSuccessMsg: null,
  changeError: null
};

const updatePassword = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PASSWORD:
      state = {
        ...state,
        changeSuccessMsg: null,
        changeError: null
      };
      break;
    case UPDATE_PASSWORD_SUCCESS:
      state = {
        ...state,
        changeSuccessMsg: action.payload
      };
      break;
    case UPDATE_PASSWORD_ERROR:
      state = { 
        ...state, 
        changeError: action.payload 
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default updatePassword;
  